export async function getClientsForWoco(woco, projects, group = null) {
  let response
  let json
  let message = 'Success'
  let status = 'OK'
  const acceptedResponses = [200, 201, 204, 206]

  try {
    const url = `/api/woco/${woco}/clients/`

    let body = {
      projects,
    }

    if (group) {
      body = { ...body, group }
    }

    const options = {
      method: 'PUT',
      credentials: 'include',
      mode: 'cors',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(body),
    }

    response = await fetch(url, options)
    json = await response.json()
    if (!acceptedResponses.includes(response.status)) {
      message = 'Service niet beschikbaar. Probeer het later opnieuw.'
      status = 'error'
    }
  } catch (err) {
    message = 'Service niet beschikbaar. Probeer het later opnieuw.'
    status = 'error'
  }
  return {
    response,
    json,
    message,
    status,
  }
}

export async function getData(url) {
  try {
    const response = await fetch(url)
    const json = await response.json()
    return { ...json, statusCode: response.status } // data, message, status
  } catch (err) {
    return {
      data: [],
      message: 'Service niet beschikbaar. Probeer het later opnieuw.',
      status: 'error',
    }
  }
}

export async function postData(method, url, data) {
  try {
    const options = {
      method,
      credentials: 'include',
      mode: 'cors',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(data),
    }

    const response = await fetch(url, options)
    const json = await response.json()
    return { ...json, statusCode: response.status }
  } catch (err) {
    return {
      status: 'error',
      message: 'Internal Server Error',
    }
  }
}

export async function postDataBlob(method, url, data) {
  let response
  let blob
  const message = 'Success'
  const status = 'OK'

  try {
    const options = {
      method,
      credentials: 'include',
      mode: 'cors',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify(data),
    }

    response = await fetch(url, options)
    blob = await response.blob()

    return {
      blob,
      message,
      status,
    }
  } catch (err) {
    return {
      message: 'Server error',
      status: 'error',
    }
  }
}

export function getTaskDataForClient() {
  return {
    image: 'https://ca.slack-edge.com/T0GR3G0R2-U01CG5K5129-39b8d838f4da-512',
  }
}

export async function getFieldHistoryForHousehold(address) {
  let response
  let json
  let message = 'Success'
  let status = 'OK'

  try {
    response = await fetch(`/api/client/household/${address}/history/`)
    json = await response.json()
    if (response.status !== 200) {
      message = 'Service niet beschikbaar. Probeer het later opnieuw.'
      status = 'error'
    }
  } catch (err) {
    message = 'Service niet beschikbaar. Probeer het later opnieuw.'
    status = 'error'
  }
  return {
    response,
    json,
    message,
    status,
  }
}

// Screen permissions rarely change: cache them in memory per page load,
// cleared on login/logout via clearScreenPermissionsCache
let screenPermissionsCache = null

export function clearScreenPermissionsCache() {
  screenPermissionsCache = null
}

export async function getScreenPermissions() {
  if (screenPermissionsCache) {
    return screenPermissionsCache
  }
  try {
    const response = await fetch('/api/screen/permissions/')
    const json = await response.json()
    const result = { ...json, statusCode: response.status }
    if (response.ok) {
      screenPermissionsCache = result
    }
    return result
  } catch (err) {
    return {
      data: [],
      message: 'Service niet beschikbaar. Probeer het later opnieuw.',
      status: 'error',
    }
  }
}

export async function getDashboardInfo(woco, projects, groups) {
  try {
    const url = `/api/woco/${woco}/dashboard/`

    const options = {
      method: 'PUT',
      credentials: 'include',
      mode: 'cors',
      headers: {
        'content-type': 'application/json',
      },
      body: JSON.stringify({
        projects,
        groups,
      }),
    }

    const response = await fetch(url, options)

    const json = await response.json()
    return { ...json, statusCode: response.status }
  } catch (err) {
    return {
      data: [],
      message: 'Service niet beschikbaar. Probeer het later opnieuw.',
      status: 'error',
    }
  }
}

export async function getContract(address, contractType, contractID, filename) {
  try {
    const response = await fetch(
      `/api/household/${address}/contract/${contractType}/${filename}/${contractID}/`
    )
    const json = await response.json()
    return { ...json, statusCode: response.status }
  } catch (err) {
    return {
      data: [],
      message: 'Service niet beschikbaar. Probeer het later opnieuw.',
      status: 'error',
    }
  }
}

export async function getContractBlob(address, contractType, contractID, filename) {
  try {
    const response = await fetch(
      `/api/household/${address}/contract/${contractType}/${contractID}/${filename}/downloadable/`
    )
    const json = await response.json()
    return { ...json, statusCode: response.status }
  } catch (err) {
    return {
      data: [],
      message: 'Service niet beschikbaar. Probeer het later opnieuw.',
      status: 'error',
    }
  }
}

export async function getAsbuilt(addressPostcode, asbuiltFilename) {
  try {
    const response = await fetch(`/api/household/${addressPostcode}/asbuilt/${asbuiltFilename}/`)
    const json = await response.json()
    return { ...json, statusCode: response.status }
  } catch (err) {
    return {
      data: [],
      message: 'Service niet beschikbaar. Probeer het later opnieuw.',
      status: 'error',
    }
  }
}

export async function getImage(filePath) {
  try {
    const response = await fetch(
      `api/household/images?` +
        new URLSearchParams({
          file_path: filePath,
        })
    )
    const json = await response.json()
    return { ...json, statusCode: response.status }
  } catch (err) {
    return {
      data: [],
      message: 'Service niet beschikbaar. Probeer het later opnieuw.',
      status: 'error',
    }
  }
}

export async function downloadFiles(addresses, fileType) {
  try {
    const response = await fetch(`/api/household/files/${fileType}/`, {
      method: 'POST',
      body: JSON.stringify(addresses),
    })
    const json = await response.json()
    return { ...json, statusCode: response.status }
  } catch (err) {
    console.log(err)
    return {
      data: [],
      message: 'Service niet beschikbaar. Probeer het later opnieuw.',
      status: 'error',
    }
  }
}

export async function checkAddresses(addresses, onProgress) {
  // Grote lijsten in delen versturen, anders loopt de postcode check tegen een timeout aan
  const chunkSize = 100
  const data = []
  let failedChunks = 0

  for (let i = 0; i < addresses.length; i += chunkSize) {
    const chunk = addresses.slice(i, i + chunkSize)

    let json = null
    for (let attempt = 0; attempt < 2 && !json; attempt++) {
      try {
        const response = await fetch(`/tickets/api/v1/addresses`, {
          method: 'POST',
          body: JSON.stringify({ addresses: chunk }),
          headers: {
            'Content-Type': 'application/json',
          },
        })
        if (response.ok) {
          json = await response.json()
        }
      } catch (err) {
        console.error(err)
      }
    }

    if (json) {
      data.push(...json.data)
    } else {
      failedChunks++
      data.push(
        ...chunk.map((address) => ({
          postal_code: address.postal_code,
          house_number: address.house_number,
          message: 'Adrescheck niet gelukt, adres is niet gecontroleerd',
          level: 'warning',
        }))
      )
    }

    onProgress?.(Math.min(i + chunkSize, addresses.length), addresses.length)
  }

  if (addresses.length && !data.length) {
    return {
      data: [],
      message: 'Service niet beschikbaar. Probeer het later opnieuw.',
      status: 'error',
    }
  }

  return { data, status: 'OK', statusCode: 200, failedChunks }
}

export async function updateTenant(personId, name, email, phone) {
  try {
    const response = await fetch(`/tickets/api/v1/tenants/${personId}`, {
      method: 'PUT',
      body: JSON.stringify({ name, email, phone }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
    const json = await response.json()
    return { ...json, statusCode: response.status }
  } catch (err) {
    console.log(err)
    return {
      data: [],
      message: 'Service niet beschikbaar. Probeer het later opnieuw.',
      status: 'error',
    }
  }
}
